/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-11 14:05:30
 *
 *******************************************************/
// @flow
//
import React, { Component } from 'react';
import { Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Mavi from 'src/assets/images/subscription/mavi-gray.png';
import Durex from 'src/assets/images/subscription/durex-gray.png';
import Lacoste from 'src/assets/images/subscription/lacoste-gray.png';
import Diesel from 'src/assets/images/subscription/diesel-gray.png';
import GAP from 'src/assets/images/subscription/gap-gray.png';
import Scholl from 'src/assets/images/subscription/scholl-gray.png';
// import Customer from 'src/assets/images/subscription/customer.svg';
// import ShopifyPlus from 'src/assets/images/subscription/shopify-plus.svg';
// import FiveStarReviews from 'src/assets/images/subscription/5-star-reviews.svg';
// import Rating from 'src/assets/images/subscription/rating.svg';
// import LiveChat from 'src/assets/images/subscription/live-chat.svg';
// import MoneyBack from 'src/assets/images/subscription/money-back.svg';
// import Star from 'src/assets/images/subscription/star.svg';

class PlansReview extends Component<WithI18nProps> {
  renderBrand = () => {
    const { i18n } = this.props;
    const brands = [
      { src: Mavi, style: { maxWidth: '100px', maxHeight: '70px' }, alt: 'Mavi' },
      { src: Durex, style: { maxWidth: '100px', maxHeight: '71px' }, alt: 'Durex' },
      { src: Lacoste, style: { maxWidth: '186px', maxHeight: '56px' }, alt: 'Lacoste' },
      { src: Diesel, style: { maxWidth: '135px', maxHeight: '52px' }, alt: 'Diesel' },
      { src: GAP, style: { maxWidth: '45px', maxHeight: '52px' }, alt: 'GAP' },
      {
        src: Scholl,
        style: { maxHeight: '45px' },
        alt: 'Scholl'
      }
    ];
    return (
      <div className="brand">
        <div className="align-center card-title-uppercase">
          <Heading>{i18n.translate('AdminHTML.Subscription.PlansReview.brandsTrustUs')}</Heading>
        </div>
        <div className="brand-items">
          {brands.map((item, index) => (
            <img className="icon" src={item.src} alt={item.alt} style={item.style} key={index} />
          ))}
        </div>
      </div>
    );
  };

  // renderReview = () => {
  //   const { i18n } = this.props;
  //   const reviews = [
  //     {
  //       star: 5,
  //       reviewer: "L'Arbre à Café",
  //       review:
  //         'The filter functionality is very versatile and and customizable. Very powerful combined with metafields. The support team is very reactive and solution oriented. Exactly what I expect as a Shopify Partner Agency.'
  //     },
  //     {
  //       star: 5,
  //       reviewer: 'Headphone Zone',
  //       review:
  //         'It’s really easy to use, saves us time and runs smoothly. Our customers find using the filters really convenient. Definitely going to recommend it to all Shopify store owners we know who could benefit from such intense collection-specific filtering and search function.'
  //     },
  //     {
  //       star: 5,
  //       reviewer: 'Off the Wagon Shop',
  //       review:
  //         'A versatile app that does wonders for search results and menus. Prompt customer service. I contacted them with a question and they promptly answered me and helped me to move out of stock items to the end of the search results.'
  //     },
  //     {
  //       star: 5,
  //       reviewer: 'House of Avi',
  //       review:
  //         'Ever since I have used this app on my store my Customers have found it super easy to browse my Shoes and their Sizes super quick. Customer Service is just freaking awesome and I have always had solutions provided within hours of asking for help. About to open my second shoe store and will be using this app again - HIGHLY RECOMMENDED FOR ONLINE STORES :)'
  //     },
  //     {
  //       star: 5,
  //       reviewer: 'Fearless mind',
  //       review: `Absolutely amazing app! I recommend it because it's what all e-commerce stores need. Customers are looking to make purchases fast and easy which is what the app "product filter & search" successfully accomplishes. Most importantly, I've had many questions quickly answered by the support team. I can't thank them enough. They are terrific and truly care about their customers. A++++ for the app and team at Boost Commerce!`
  //     }
  //   ];
  //   return (
  //     <div className="review">
  //       <div className="align-center card-title-uppercase title">
  //         <Heading>{i18n.translate('AdminHTML.Subscription.PlansReview.customersReview')}</Heading>
  //       </div>
  //       <div>
  //         <Layout>
  //           <Layout.Section oneThird>
  //             <div className="utilities">
  //               <div>
  //                 <img className="icon" src={Customer} alt="9,000+ customers" />
  //                 <Heading>
  //                   {i18n.translate('AdminHTML.Subscription.PlansReview.customers', {
  //                     nt_break_line: <br />
  //                   })}
  //                 </Heading>
  //               </div>
  //               <div>
  //                 <img className="icon" src={ShopifyPlus} alt="1,500+ Shopify Plus stores" />
  //                 <Heading>
  //                   {i18n.translate('AdminHTML.Subscription.PlansReview.shopifyPlusStores', {
  //                     nt_break_line: <br />
  //                   })}
  //                 </Heading>
  //               </div>
  //             </div>
  //             <div className="utilities">
  //               <div>
  //                 <img className="icon" src={FiveStarReviews} alt="800+ 5-star reviews" />
  //                 <Heading>
  //                   {i18n.translate('AdminHTML.Subscription.PlansReview.fiveStarReviews', {
  //                     nt_break_line: <br />
  //                   })}
  //                 </Heading>
  //               </div>
  //               <div>
  //                 <img className="icon" src={Rating} alt="Rating 4.9/5" />
  //                 <Heading>{i18n.translate('AdminHTML.Subscription.PlansReview.rating')}</Heading>
  //               </div>
  //             </div>
  //             <div className="utilities">
  //               <div>
  //                 <img className="icon" src={LiveChat} alt="Live chat available 24/6" />
  //                 <Heading>
  //                   {i18n.translate('AdminHTML.Subscription.PlansReview.liveChat', {
  //                     nt_break_line: <br />
  //                   })}
  //                 </Heading>
  //               </div>
  //               <div>
  //                 <img className="icon" src={MoneyBack} alt="Cancel anytime. 30-day money-back" />
  //                 <Heading>
  //                   {i18n.translate('AdminHTML.Subscription.PlansReview.moneyBack', {
  //                     nt_break_line: <br />
  //                   })}
  //                 </Heading>
  //               </div>
  //             </div>
  //           </Layout.Section>
  //           <Layout.Section>
  //             <Scrollable shadow style={{ height: '35rem', paddingRight: '5px' }} focusable>
  //               {reviews.map((item, index) => (
  //                 <Card key={index}>
  //                   <Card.Section>
  //                     <div className="review-info">
  //                       {this.renderStar(item.star)}
  //                       <span className="reviewer">
  //                         <Heading>{item.reviewer}</Heading>
  //                       </span>
  //                     </div>
  //                     <div className="review-content">"{item.review}"</div>
  //                   </Card.Section>
  //                 </Card>
  //               ))}
  //             </Scrollable>
  //           </Layout.Section>
  //         </Layout>
  //       </div>
  //     </div>
  //   );
  // };

  // renderStar = star => {
  //   if (!star) return;
  //   return (
  //     <span className="star-review">
  //       {Array(star)
  //         .fill(1)
  //         .map((el, i) => (
  //           <img className="star" src={Star} alt="star" key={i} />
  //         ))}
  //     </span>
  //   );
  // };

  render() {
    return (
      <div>
        {this.renderBrand()}
        {/* {this.renderReview()} */}
      </div>
    );
  }
}

export default withI18n()(PlansReview);
